import create from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { CompanyResponseDTO } from '../../api-client/generated/api';

interface CompanyState {
  company: CompanyResponseDTO | null;
  getCompany: () => CompanyResponseDTO | null;
  isLoading: boolean;
  setCompany: (data: CompanyResponseDTO) => void;
}

const useCompanyStore = create<CompanyState>()(
  devtools(
    persist(
      (set, get) => ({
        company: null,
        getCompany: () => {
          return get().company;
        },

        isLoading: false,

        setCompany: (data: CompanyResponseDTO) => {
          set({ company: data });
        }
      }),
      {
        name: 'company-storage'
      }
    )
  )
);

export default useCompanyStore;
